// extracted by mini-css-extract-plugin
export default {"chatText-container":"chatText_chatText-container__-lDq2"};